module.exports = __webpack_public_path__ + "static/d178c536-6270-44f0-9f1c-8cff79fa1869-5d1b1b2d782ed385667ba2c22a47b1f6.webp";